import { Select, SelectProps } from "@mantine/core";

export function ESelect({ ...props }: SelectProps) {
  return (
    <Select
      radius={"md"}
      size={"md"}
      labelProps={{ className: "mb-1 text-sm ", style: { fontSize: "14px" } }}
      {...props}
      comboboxProps={{
        transitionProps: { transition: "fade-down", duration: 200 },
        ...props.comboboxProps,
      }}
    />
  );
}
